
import * as React from "react";

import {
    Grid,
    PricingCard,
} from "tabler-react";

interface HelloMessageProps {
}

export default class Leistungen extends React.Component<HelloMessageProps, {}>{
    render() {
        return (<Grid.Row>
            <Grid.Col width={12} sm={6} md={6} lg={4} xl={3}>

                <PricingCard active>
                    <PricingCard.Category>{"IT-Contractor"}</PricingCard.Category>
                    <PricingCard.AttributeList>
                        <PricingCard.AttributeItem>
                            <strong>Software Entwickler</strong>
                        </PricingCard.AttributeItem>
                    </PricingCard.AttributeList>
                    <PricingCard.Price>{"86€"} </PricingCard.Price>
                    <PricingCard.AttributeList>
                        <PricingCard.AttributeItem>
                            <strong>plus 19% </strong>
                            {"Umsatzsteuer"}
                        </PricingCard.AttributeItem>
                        <PricingCard.AttributeItem hasIcon available>
                            {"In House"}
                        </PricingCard.AttributeItem>
                        <PricingCard.AttributeItem hasIcon available>
                            {"Software-Entwicklung"}
                        </PricingCard.AttributeItem>
                        <PricingCard.AttributeItem hasIcon available>
                            {"Programmierung"}
                        </PricingCard.AttributeItem>
                        <PricingCard.AttributeItem hasIcon available>
                            {"Dienstvertrag"}
                        </PricingCard.AttributeItem>
                        <PricingCard.AttributeItem hasIcon available={false}>
                            {"Werkvertrag"}
                        </PricingCard.AttributeItem>
                    </PricingCard.AttributeList>
                </PricingCard>
            </Grid.Col>
            <Grid.Col width={12} sm={6} md={6} lg={4} xl={3}>
                <PricingCard active>
                    <PricingCard.Category>{"Amazon Custom"}</PricingCard.Category>
                    <PricingCard.AttributeList>
                        <PricingCard.AttributeItem>
                            <strong>personalisiertes Produkt</strong>
                        </PricingCard.AttributeItem>
                        <PricingCard.AttributeItem>
                            <strong>bei Amazon Listen</strong>
                        </PricingCard.AttributeItem>
                    </PricingCard.AttributeList>
                    <PricingCard.Price>{"4398€"} </PricingCard.Price>
                    <PricingCard.AttributeList>
                        <PricingCard.AttributeItem>
                            <strong>plus 19% </strong>
                            {"Umsatzsteuer"}
                        </PricingCard.AttributeItem>
                        <PricingCard.AttributeItem hasIcon available>
                            {"Beratung"}
                        </PricingCard.AttributeItem>
                        <PricingCard.AttributeItem hasIcon available>
                            {"2 Bilder und 8 Fonts"}
                        </PricingCard.AttributeItem>
                        <PricingCard.AttributeItem hasIcon available>
                            {"Produkt aktivieren"}
                        </PricingCard.AttributeItem>
                        <PricingCard.AttributeItem hasIcon available>
                            {"Angebot einrichten"}
                        </PricingCard.AttributeItem>
                    </PricingCard.AttributeList>
                </PricingCard>
            </Grid.Col>
           
        </Grid.Row>);
    }
}

/*
 <Grid.Col width={12} sm={6} md={6} lg={4} xl={3}>
                <PricingCard active>
                    <PricingCard.Category>{"HourMgr"}</PricingCard.Category>
                    <PricingCard.AttributeList>
                        <PricingCard.AttributeItem>
                            <strong>Arbeitszeiterfassung</strong>
                        </PricingCard.AttributeItem>
                        <PricingCard.AttributeItem>
                            <strong>monatliche Miete pro Mitarbeiter</strong>
                        </PricingCard.AttributeItem>
                    </PricingCard.AttributeList>
                    <PricingCard.Price>{"1 €"} </PricingCard.Price>
                    <PricingCard.AttributeList>
                        <PricingCard.AttributeItem>
                            <strong>plus 19% </strong>
                            {"Umsatzsteuer"}
                        </PricingCard.AttributeItem>
                        <PricingCard.AttributeItem>
                            {"zusätzlich AWS kosten bei Amazon"}
                        </PricingCard.AttributeItem>
                        <PricingCard.AttributeItem>
                            {"Mindest Vertagslaufzeit 1 Jahr"}
                        </PricingCard.AttributeItem>
                        <PricingCard.AttributeItem hasIcon available>
                            {"Produkt einrichten"}
                        </PricingCard.AttributeItem>
                        <PricingCard.AttributeItem hasIcon available>
                            {"Einweisung per TeamViewer "}
                        </PricingCard.AttributeItem>
                    </PricingCard.AttributeList>
                </PricingCard>
            </Grid.Col>

*/